import React from 'react';
import { withRouter } from 'react-router-dom';
import TemplateExterno from '../interfaz/TemplateExterno';
import {Button, Card, Row, Col, Divider, Icon} from 'antd';
import imgSupervisores from '../../img/icono_supervisores.svg';
import imgCapacitadores  from '../../img/icono_capacitadores.svg';
import * as etiquetas from '../../ApplicationResources';

class QueHaceSEyCAE extends React.Component {
    constructor(props) {
        super(props);
    }

    redireccionInicioSesion = () => {
		this.props.history.goBack();
	}

    redireccionRegistroAspirante = () => {
        this.props.history.push('/registro_aspirante')
    }

    render() {
        return(
            <TemplateExterno enlaces={true}>
                <>
                    <Row>
                        <Col xs={3} sm={3} md={3} lg={3} className='col_bton_regresar'>
                            <Button type="primary"
									className="button_style"
									id="btn-sesion"
									style={{backgroundColor: '#FFFFFF', color:'#333333', border:'1px solid #333333'}}
									onClick={this.redireccionInicioSesion}>
									<Icon type="arrow-left" style={{ color: '#333333' }} /> Regresar
							</Button>
                        </Col>
                        <Col xs={22} sm={22} md={22} lg={20}>
                            <Row>
                                <Card bordered={false}>
                                    <Row>
										<Col xs={24} sm={24} md={{span: 2, offset: 6}} lg={{span: 2, offset: 6}} className='login_border_col'>		
											<img src={imgSupervisores} alt="" />
										</Col>
										<Col xs={24} sm={24} md={16} lg={16}>
											<span className='login_etiquetas_texto_qh'>{etiquetas.login_lbl_carousel_title_que_hace}&nbsp;</span>
											<span className='login_etiquetas_capacitador_supervisor_qh'>{etiquetas.login_lbl_carousel_title_supervisores}</span>
										</Col>
									</Row>
									<br></br>
									<Row>
										<Col xs={24} sm={24} md={24} lg={24}>
										    <Col xs={24} sm={24} md={24} lg={22} className='text_col_carousel'>
												<ul>
													<li>
														<span className='login_etiquetas_texto_carousel_2'>{etiquetas.que_hace_lbl_supervisor_texto_uno}&nbsp;</span>
													</li>
													<br></br>
													<li>
													    <span className='login_etiquetas_texto_carousel_2'>{etiquetas.que_hace_lbl_supervisor_texto_dos}&nbsp;</span>
													</li>
													<br></br>
													<li>
														<span className='login_etiquetas_texto_carousel_2'>{etiquetas.que_hace_lbl_supervisor_texto_tres}&nbsp;</span>
													</li>
													<br></br>
													<li>
													    <span className='login_etiquetas_texto_carousel_2'>{etiquetas.que_hace_lbl_supervisor_texto_cuatro}&nbsp;</span>
													</li>
												</ul>
											</Col>
										</Col>
									</Row>
                                    <Divider />
                                    <br></br>
                                    <Row>
                                        <Col xs={24} sm={24} md={{span: 2, offset: 6}} lg={{span: 2,offset: 6}} className='login_border_col'>		
											<img src={imgCapacitadores} alt="" />
										</Col>
										<Col xs={24} sm={24} md={16} lg={16}>
											<span className='login_etiquetas_texto_qh'>{etiquetas.login_lbl_carousel_title_que_hace}&nbsp;</span>
											<span className='login_etiquetas_capacitador_supervisor_qh'>{etiquetas.login_lbl_carousel_title_capacitador}</span>
										</Col>
									</Row>
									<br></br>
									<Row>
										<Col xs={24} sm={24} md={24} lg={24}>
										    <Col xs={24} sm={24} md={24} lg={22} className='text_col_carousel'>
												<ul>
													<li>
														<span className='login_etiquetas_texto_carousel_2'>{etiquetas.que_hace_lbl_capacitor_texto_uno}&nbsp;</span>
													</li>
													<br></br>
													<li>
													    <span className='login_etiquetas_texto_carousel_2'>{etiquetas.que_hace_lbl_capacitor_texto_dos}&nbsp;</span>
													</li>
													<br></br>
                                                    <li>
													    <span className='login_etiquetas_texto_carousel_2'>{etiquetas.que_hace_lbl_capacitor_texto_tres}&nbsp;</span>
													</li>
													<br></br>
                                                    <li>
													    <span className='login_etiquetas_texto_carousel_2'>{etiquetas.que_hace_lbl_capacitor_texto_cuatro}&nbsp;</span>
													</li>
												</ul>
											</Col>
										</Col>
									</Row>
									<Divider />
                                    <Row>
										<Col xs={24} sm={24} md={24} lg={22} className='col_bton_registrarse'>
                                            <Button type="primary"
											        className="button_style"
											        id="btn-registrarse"
											        onClick={this.redireccionRegistroAspirante}>
                                                    <Icon type="form" />Registrarse
									        </Button>
										</Col>
									</Row>
                                </Card>
                            </Row>
                        </Col>
                    </Row>
                </>

            </TemplateExterno>
        );
    }
}


export default withRouter(QueHaceSEyCAE);